<template>
  <p>
    ご入力のメールアドレス宛にメールを送信しました。<br>
    メールに記載されているURLより発行依頼をご登録ください。
  </p>
</template>

<script>
export default {
  name: 'GuestRegisterComplete',
}
</script>
